module.exports = __webpack_public_path__ + "static/media/award1@2x.57576ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/award1@2x.png
// module id = 1124
// module chunks = 0